import React from 'react';
import Icon from '@Components/Icon';

const Toast = ({message, anchor, fillColor = 'fill--off-white-alpha-50'}) => {
  const attrID = {[`data-rs-toast-${anchor}`]: true};

  const messageCapitalized = message ? message.charAt(0).toUpperCase() + message.slice(1) : '';

  return (
    <div
      className="toast bg-variant-brand-secondary"
      data-rs-toast-anchor={anchor}
      data-rs-toast={anchor}
      {...attrID}
    >
      <p className="toast__message">{messageCapitalized}</p>
      <button
        className="button--icon-only"
        data-rs-closable={`data-rs-toast-${anchor}`}
      >
        <span className={`icon ${fillColor}`}>
          <Icon type="close"/>
        </span>
      </button>
    </div>
  );
};

export default Toast;
